module.exports = __webpack_public_path__ + "img/mv-mishina.819fac9a.png";